import { useCallback } from "react";
import client from "../helpers/network/client";
import { Teacher, TeacherDto } from "../models/teacher/teacher";
import useCache from "../hooks/useCache";

const getTeacher = (id: string) => {
  return client
    .get<TeacherDto>(`teacher/email/${encodeURIComponent(id)}`)
    .then((r) => r.data);
};

export const useTeacherApi = () => {
  const { fetchWithCache } = useCache();

  const _getTeacher = useCallback(async (id: string) => {
    const teacher = await fetchWithCache({ type: "teacher", key: id }, () =>
      getTeacher(id),
    );
    return Teacher.fromTeacherDto(teacher);
  }, [fetchWithCache]);

  return {
    getTeacher: _getTeacher,
  };
};
